import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 60000 });

// Shared farm-context that gets merged into every advisory request so runs
// are automatically persisted in the per-farm history collection.
let _context = { farm_id: null, farmer_id: null };
export const setApiContext = (ctx) => { _context = { ..._context, ...ctx }; };
const withCtx = (payload = {}) => ({ ..._context, ...payload });

export const api = {
  // Farmers
  listFarmers: () => client.get('/farmers').then(r => r.data.farmers),
  createFarmer: (payload) => client.post('/farmers', payload).then(r => r.data),
  farmerDashboard: (farmerId) => client.get(`/farmers/${farmerId}/dashboard`).then(r => r.data),
  publicStats:  () => client.get('/stats').then(r => r.data),
  // Farms
  listFarms: (farmerId) => client.get('/farms', { params: farmerId ? { farmer_id: farmerId } : {} }).then(r => r.data.farms),
  createFarm: (payload) => client.post('/farms', payload).then(r => r.data),
  // Crops
  listCrops: () => client.get('/crops').then(r => r.data.crops),
  // Advisory (auto-tagged with farm context)
  suitability: (payload) => client.post('/advisory/suitability', withCtx(payload)).then(r => r.data),
  cropSelection: (payload) => client.post('/advisory/crop-selection', withCtx(payload)).then(r => r.data),
  cropSelectionHires: (payload) => client.post('/advisory/crop-selection/hires', withCtx(payload)).then(r => r.data),
  dndc: (payload) => client.post('/advisory/dndc', withCtx(payload)).then(r => r.data),
  sowingCalendar: (payload) => client.post('/advisory/sowing/calendar', withCtx(payload)).then(r => r.data),
  sowingIsat: (payload) => client.post('/advisory/sowing/isat', withCtx(payload)).then(r => r.data),
  sowingIsatMeta: () => client.get('/advisory/sowing/isat/meta').then(r => r.data),
  weather: (payload) => client.post('/advisory/weather', withCtx(payload)).then(r => r.data),
  irrigation: (payload) => client.post('/advisory/irrigation', withCtx(payload)).then(r => r.data),
  nutrient: (payload) => client.post('/advisory/nutrient', withCtx(payload)).then(r => r.data),
  growth: (payload) => client.post('/advisory/growth', withCtx(payload)).then(r => r.data),
  ndvi:   (payload) => client.post('/advisory/ndvi', withCtx(payload)).then(r => r.data),
  harvest: (payload) => client.post('/advisory/harvest', withCtx(payload)).then(r => r.data),
  marketMsp: (payload) => client.post('/advisory/market/msp', withCtx(payload)).then(r => r.data),
  marketMandi: (payload) => client.post('/advisory/market/mandi', withCtx(payload)).then(r => r.data),
  marketMandiCompare: (payload) => client.post('/advisory/market/mandi/compare', withCtx(payload)).then(r => r.data),
  landCover: (payload) => client.post('/advisory/land-cover', withCtx(payload)).then(r => r.data),
  aiAdvisor: (payload) => client.post('/advisor/ai', payload).then(r => r.data),
  finalPlan: (payload) => client.post('/advisor/final-plan', withCtx(payload)).then(r => r.data),
  photoDiagnosis: (payload) => client.post('/advisor/photo-diagnosis', withCtx(payload), { timeout: 90000 }).then(r => r.data),
  // History / trends
  history: (farmId, advisoryType) => client.get('/history', { params: { farm_id: farmId, advisory_type: advisoryType } }).then(r => r.data),
  farmAnalytics: (farmId) => client.get(`/analytics/farm/${farmId}`).then(r => r.data),
};
